export const PERSONAL_CONTACTS_LOADED_SUCCESS = 'PERSONAL_CONTACTS_LOADED_SUCCESS';
export const PERSONAL_CONTACT_LOADED_SUCCESS = 'PERSONAL_CONTACT_LOADED_SUCCESS';
export const PERSONAL_CONTACTS_ENABLED_ACCESS = 'PERSONAL_CONTACTS_ENABLED_ACCESS';
export const PERSONAL_CONTACTS_DISABLED_ACCESS = 'PERSONAL_CONTACTS_DISABLED_ACCESS';
export const PERSONAL_CONTACTS_UNLOCKED_ACCOUNT = 'PERSONAL_CONTACTS_UNLOCKED_ACCOUNT';
export const PERSONAL_CONTACTS_PASSWORD_RESET = 'PERSONAL_CONTACTS_PASSWORD_RESET';
export const PERSONAL_CONTACTS_CLEAR_FLAGS = 'PERSONAL_CONTACTS_CLEAR_FLAGS';

export const PERSONAL_CONTACTS_SET_CONTACTID = 'PERSONAL_CONTACTS_SET_CONTACTID';
